import useBSSLogger from "./useBSSLogger";

const {logger} = useBSSLogger();

/**
 * @inutilizzato
 * @param {*} cb 
 */
const useBSSErrorManager = ({setError, eventName = "spedizioniweb2_error", customHandler = null}) => {

    let handler = (error) => {
        logger.debug("si è verificato un errore", eventName, error)

        var selector = BSSComps_spedizioniweb2_utili?.firstElementSelector ?? null;

        if(selector === null){
            window.scrollTo({top: 0, behavior: "smooth"})
        } else {
            document.querySelector(selector).scrollIntoView()
        }
    

        setError({
            show: true, 
            message: error.detail.message ?? error.detail, 
            payload: error.payload ?? null, 
            context: error.context, 
            originalError: error.detail.originalError ?? null
        })
    }

    if(customHandler !== null){
        handler = customHandler;
    }

    
    logger.finest("registro l'evento", eventName)
    document.addEventListener(eventName, handler);
    

}

export default useBSSErrorManager;